import { ArrowUpRight } from "lucide-react";
import type { ReactNode } from "react";

export function ActionLink({
  href,
  children,
}: {
  href: string;
  children: ReactNode;
}) {
  return (
    <a
      href={href}
      className="inline-flex items-center gap-1 rounded-lg bg-white/80 px-2.5 py-1.5 text-xs font-semibold text-lumen-700 hover:bg-white dark:bg-black/10 dark:text-lumen-300"
    >
      {children} <ArrowUpRight size={12} />
    </a>
  );
}
